import { createSlice } from "@reduxjs/toolkit";
import { createInvoice, getInvoicesList } from "./thunk";

interface InvoicingState {
  isLoading: boolean;
  error: string | null;
  lastInvoice: any | null;
  invoices: any[];
  meta: any | null;
}

export const initialState: InvoicingState = {
  isLoading: false,
  error: null,
  lastInvoice: null,
  invoices: [],
  meta: null,
};

const invoicingSlice = createSlice({
  name: "invoicing",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createInvoice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createInvoice.fulfilled, (state, action: any) => {
        state.isLoading = false;
        state.lastInvoice = action.payload;
      })
      .addCase(createInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || null;
      })
      .addCase(getInvoicesList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInvoicesList.fulfilled, (state, action: any) => {
        state.isLoading = false;
        state.invoices = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(getInvoicesList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || null;
      });
  },
});

export default invoicingSlice.reducer;
